module.exports = __webpack_public_path__ + "static/media/cartoon_rank_bg.c4d5582c.png";